import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase =
  supabaseUrl && supabaseAnonKey ? createClient(supabaseUrl, supabaseAnonKey) : null;

export const fetchTotalAttempts = async () => {
  if (!supabase) return null;

  const { data, error } = await supabase
    .from('quiz_stats')
    .select('total_attempts')
    .eq('id', 1)
    .single();

  if (error) {
    console.error('Failed to fetch quiz attempts', error);
    return null;
  }

  return data?.total_attempts ?? null;
};

export const incrementTotalAttempts = async () => {
  if (!supabase) return null;

  const { data, error } = await supabase.rpc('increment_quiz_attempts');

  if (error) {
    console.error('Failed to increment quiz attempts', error);
    return null;
  }

  // RPC may return a row object or an array of one row depending on definition.
  if (Array.isArray(data)) {
    return data[0]?.total_attempts ?? null;
  }

  return data?.total_attempts ?? null;
};
